import { Loader2 } from "lucide-react";
import type { Dispatch, SetStateAction } from "react";
import { ResponsiveModal } from "@/components/responsive-modal";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/locales/client";
import { useDeleteQuestion } from "../api/use-delete-question";

interface DeleteQuestionProps {
  studySetId: string;
  questionId: string;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  onDelete?: () => void;
}

export const DeleteQuestionModal = ({
  studySetId,
  questionId,
  isOpen,
  setIsOpen,
  onDelete,
}: DeleteQuestionProps) => {
  const t = useI18n();
  const deleteQuestionMutation = useDeleteQuestion({
    id: studySetId,
    questionId: questionId,
  });
  const deleteQuestion = async () => {
    deleteQuestionMutation.mutate(
      {
        id: studySetId,
        questionId,
      },
      {
        onSuccess: () => {
          onDelete?.();
          setIsOpen(false);
        },
      },
    );
  };
  return (
    <ResponsiveModal
      title={t("questionActions.delete.title")}
      description={t("questionActions.delete.description")}
      open={isOpen}
      onOpenChange={setIsOpen}
      form={
        <div className="flex flex-col-reverse gap-y-2 md:gap-y-0 md:flex-row w-full md:items-center md:justify-between">
          {" "}
          <Button variant="outline" onClick={() => setIsOpen(false)}>
            {t("questionActions.delete.cancel")}
          </Button>
          <Button
            variant={"destructive"}
            disabled={deleteQuestionMutation.isPending}
            onClick={deleteQuestion}
          >
            {deleteQuestionMutation.isPending ? (
              <div className="flex items-center justify-center gap-2">
                <Loader2 className="size-4 animate-spin" />
                <p>{t("questionActions.delete.deleting")}</p>
              </div>
            ) : (
              t("questionActions.delete.delete")
            )}
          </Button>
        </div>
      }
    />
  );
};
